import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface QuickLink {
  title: string;
  description: string;
  icon: string;
  href: string;
}

interface QuickLinksProps {
  className?: string;
}

export default function QuickLinks({ className = '' }: QuickLinksProps) {
  const quickLinks: QuickLink[] = [
    {
      title: 'Getting Started',
      description: 'Learn how to set up and activate your ParkPing card',
      icon: 'RocketLaunchIcon',
      href: '#getting-started',
    },
    {
      title: 'Video Tutorials',
      description: 'Watch step-by-step guides for common tasks',
      icon: 'PlayCircleIcon',
      href: '#video-tutorials',
    },
    {
      title: 'FAQs',
      description: 'Find quick answers to frequently asked questions',
      icon: 'QuestionMarkCircleIcon',
      href: '#faqs',
    },
    {
      title: 'Contact Support',
      description: 'Get in touch with our support team',
      icon: 'ChatBubbleLeftRightIcon',
      href: '#contact-support',
    },
  ];

  return (
    <section className={`py-12 bg-white ${className}`}>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {quickLinks.map((link, index) => (
            <Link
              key={index}
              href={link.href}
              className="group bg-white p-6 rounded-lg border border-gray-200 hover:border-[#42AF47]/40 hover:shadow-md transition"
            >
              <div className="flex flex-col items-center text-center space-y-4">
                <div className="w-16 h-16 bg-[#42AF47]/10 rounded-full flex items-center justify-center group-hover:bg-[#42AF47]/20 transition">
                  <Icon
                    name={link.icon as any}
                    size={32}
                    className="text-[#42AF47]"
                  />
                </div>

                <h3 className="text-lg font-semibold text-gray-900">
                  {link.title}
                </h3>

                <p className="text-sm text-gray-600">
                  {link.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
